import { render, staticRenderFns } from "./HomeFeaturedSerie.vue?vue&type=template&id=2419adc0&scoped=true&"
import script from "./HomeFeaturedSerie.vue?vue&type=script&lang=js&"
export * from "./HomeFeaturedSerie.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeaturedSerie.vue?vue&type=style&index=0&id=2419adc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2419adc0",
  null
  
)

export default component.exports